import { lazy } from 'react';

import { PageSuspense } from 'src/components';


const AccountProductCartPage = lazy(() => import('../views/list/AccountProductCartPage'));

export function AccountProductCartPageLazy() {
	return (
		<PageSuspense>
			<AccountProductCartPage />
		</PageSuspense>
	);
}
